import { List } from "immutable";
import moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import { ResumeAlertsForm } from "./components";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    dataLoading: state.careerCenter.loadingJobs,
    jobs: state.careerCenter.userJobs,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    loadData: () => dispatch(Actions.CareerCenter.loadUserJobs()),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
    removeJob: (job: M.CareerCenter.JobPost) => dispatch(Actions.CareerCenter.removeFromUserJobs(job)),
    toggleLoading: (loading: boolean) => dispatch(Actions.CareerCenter.toggleJobsLoading(loading)),
    replaceHistory: (path: string) => dispatch(Actions.Router.replaceHistory(path)),
});

type OwnProps = RouteComponentProps<{
}> & {
};

interface ConnectedState {
    api: Api;
    dataLoading: boolean;
    jobs: List<M.CareerCenter.JobPost>;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    loadData: () => void;
    notifyError: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
    removeJob: (job: M.CareerCenter.JobPost) => void;
    toggleLoading: (loading: boolean) => void;
    replaceHistory: (path: string) => void;
}

interface OwnState {
    job?: M.CareerCenter.JobPost;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class UserJobsComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _confirmDelete: Comp.Modal.ConfirmModal | null = null;
    private _confirmRenew: Comp.Modal.ConfirmModal | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        await this.props.loadData();
    }

    public componentDidUpdate(prevProps: CombinedProps, prevState: OwnState) {
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>) {
        if (!this.props.jobs.size && nextProps.jobs.size === 1) {
            this.props.replaceHistory(Paths.User.CareerCenter.Jobs + "/" + nextProps.jobs.get(0).guid);
        }
    }

    public componentWillMount() {
        // get job from state if available
        if (this.props.jobs.size) {
            if (this.props.jobs.size === 1) {
                this.props.replaceHistory(Paths.User.CareerCenter.Jobs + "/" + this.props.jobs.get(0).guid);
                return;
            }
        }
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const items = this.props.jobs.size
            ? <ul className="jobs">
                {this.props.jobs.map((x, i) => {
                    if (!x)
                        return null;

                    return <li key={i}>
                        <Item
                            job={x}
                            onCopy={() => this.handleOnCopy(x)}
                            onDelete={() => this.toggleDeleteConfirmation(x)}
                            onEdit={() => this.handleOnEdit(x)}
                            onRenew={() => this.toggleRenewConfirmation(x)}
                        />
                    </li>;
                })}
            </ul>
            : null;

        const title = `Your Job Post${this.props.jobs.size === 1 || this.state.loading ? "" : "s"}`;

        return <Comp.Page.PublicPage style={{ position: "relative", minHeight: "200px" }} pageTitle={title}>
                <Comp.Generic.LoadingSpinner show={this.state.loading || this.props.dataLoading} />

                <Comp.Modal.ConfirmModal
                    headerClassName="warning"
                    onProceed={() => this.onDeleteConfirm()}
                    title="Confirm delete"
                    ref={(ref) => this._confirmDelete = ref}
                >
                    <p>Are you sure you want to delete this job post?</p>
                </Comp.Modal.ConfirmModal>

                <Comp.Modal.ConfirmModal
                    headerClassName="info"
                    labelProceed="Renew"
                    onProceed={() => this.onRenewConfirm()}
                    title="Confirm renewal"
                    ref={(ref) => this._confirmRenew = ref}
                >
                    <p>Please confirm you would like to renew this job post.</p>
                </Comp.Modal.ConfirmModal>

                <div id="content-primary">
                    <h1>
                        <Link to={Paths.User.Account}>Your Account</Link> &raquo; {title}
                    </h1>

                    <div className="btn-toolbar">
                        <BS.ButtonGroup>
                            <Link className="btn btn-primary" to={Paths.CareerCenter.Job.Post}><Comp.Generic.Icon icon="plus" /> Create new post</Link>
                        </BS.ButtonGroup>
                    </div>

                    {items}
                </div>

                <div id="content-secondary">
                    <ResumeAlertsForm />
                </div>
            </Comp.Page.PublicPage>;
    }

    private handleOnCopy(job?: M.CareerCenter.JobPost) {
        if (job)
            this.props.goto(Paths.CareerCenter.Job.Post + "?copy=" + job.guid);
    }

    private handleOnEdit(job?: M.CareerCenter.JobPost) {
        if (job && job.statusId === CareerCenterStatuses.Created.id)
            this.props.goto(Paths.CareerCenter.Job.Post + "/" + job.guid);
        else if (job)
            this.props.goto(Paths.User.CareerCenter.EditJob + "/" + job.guid);
    }

    private async onDeleteConfirm() {
        if (this._confirmDelete === null)
            return;

        const job = this._confirmDelete.getRef() as M.CareerCenter.JobPost;
        if (job === undefined) {
            this.props.notifyError("Job post is undefined in the confirmation modal.");
            return;
        }

        const qp = { queryParams: { guid: job.guid }};
        const result = await this.props.api.delete<boolean>(Api.endpoints.users.careerCenter.job, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess) {
            await this.props.removeJob(job);
            this.props.notifySuccess(`Job post <strong>${job.title}</strong> has been successfully deleted.`);
        }
        else {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
        }

        if (this._confirmDelete !== null)
            this._confirmDelete.close();
    }

    private async onRenewConfirm() {
        if (this._confirmRenew === null)
            return;

        const job = this._confirmRenew.getRef() as M.CareerCenter.JobPost;
        if (job === undefined) {
            this.props.notifyError("Job post is undefined in the confirmation modal.");
            return;
        }

        const qp = { queryParams: { guid: job.guid }};
        const result = await this.props.api.post<M.CareerCenter.JobPost>(Api.endpoints.users.careerCenter.renewJob, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess) {
            await this.props.loadData();
            this.props.notifySuccess(`Job post <strong>${job.title}</strong> has been successfully renewed.`);
        }
        else {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
        }

        if (this._confirmRenew !== null)
            this._confirmRenew.close();
    }

    private toggleDeleteConfirmation(job?: M.CareerCenter.JobPost) {
        if (job && this._confirmDelete !== null) {
            this._confirmDelete.show(job);
        }
    }

    private toggleRenewConfirmation(job?: M.CareerCenter.JobPost) {
        if (job && this._confirmRenew !== null) {
            this._confirmRenew.show(job);
        }
    }
}

export const UserJobs: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(UserJobsComponent) as any);

interface ItemProps {
    job: M.CareerCenter.JobPost;
    onCopy: () => void;
    onDelete: () => void;
    onEdit: () => void;
    onRenew: (job: M.CareerCenter.JobPost) => void;
}

const Item: React.SFC<ItemProps> = (props) => {
    const now = new Date();
    const job = props.job;
    const isDraft = CareerCenterStatuses.isDraft(job.statusId);
    let expiresOn: Date | undefined;
    let expiredDisplay = null;
    let renewDisplay = null;

    const detailsLink = isDraft
        ? Paths.CareerCenter.Job.Post + "/" + job.guid
        : Paths.User.CareerCenter.Jobs + "/" + job.guid;

    const handleOnRenewClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        props.onRenew(job);
        e.preventDefault();
        return false;
    };

    if (job.expiresOn) {
        expiresOn = Utility.utcToLocal(job.expiresOn);
        if (expiresOn) {
            expiredDisplay = now > expiresOn
                ? <li><strong>Expired {moment(expiresOn).format("MMM D, YYYY")}</strong></li>
                : <li>Expires {moment(expiresOn).format("MMM D, YYYY")}</li>;

            if (now > expiresOn)
                renewDisplay = <li><a href="#" onClick={(e) => handleOnRenewClick(e)}><strong>Renew</strong></a></li>;
        }
    }

    return <Comp.Generic.WrapperLess>
        <h3 className="jobs-title">
            <Link to={detailsLink}>{(isDraft ? "(Draft) " : "") + job.title}</Link>

            <Comp.Tools.CrudTools
                className="pull-right"
                entity="job post"
                includeCopy={!isDraft}
                onCopy={() => props.onCopy()}
                onDelete={() => props.onDelete()}
                onEdit={() => props.onEdit()}
            />
        </h3>

        <ul className="jobs-summary">
            {expiredDisplay}
            {renewDisplay}
        </ul>
    </Comp.Generic.WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/containers/user/careerCenter/UserJobs.tsx